module.exports = __webpack_public_path__ + "img/cardio11.6a242f45.jpg";